// extracted by mini-css-extract-plugin
export var container = "videoTitleTextSection-module--container--90275";
export var content = "videoTitleTextSection-module--content--2679e";
export var cropped = "videoTitleTextSection-module--cropped--71ef2";
export var image = "videoTitleTextSection-module--image--0c62b";
export var imageDesktop = "videoTitleTextSection-module--imageDesktop--bba20";
export var overlayBottom = "videoTitleTextSection-module--overlayBottom--eee2a";
export var overlayTop = "videoTitleTextSection-module--overlayTop--0c93a";
export var player = "videoTitleTextSection-module--player--d2c13";
export var reactPlayer = "videoTitleTextSection-module--reactPlayer--ef70f";
export var text = "videoTitleTextSection-module--text--d0f4e";
export var wrapper = "videoTitleTextSection-module--wrapper--42423";